import { Pipe, PipeTransform } from '@angular/core';
import { Category } from '@interfaces/Category';

@Pipe({
  name: 'categoryExpenseBillable'
})
export class CategoryExpenseBillablePipe implements PipeTransform {
  public transform(category: Category): number {
    let total = 0;

    for (const estimateLine of category.estimateLines) {
      if (estimateLine.expenseLine) {
        total += estimateLine.expenseLine.amountBillable;
      }
    }

    return total;
  }
}
